import React from 'react'

const Credits = () => {
    return <section className="Credits" lang="en">
        <h1 className="main-title">Credits</h1>
        <div>
            <p>The guide was initially posted by <strong>Hydrocarbonate</strong></p>
            <p><a href="https://www.reddit.com/r/summonerswar/comments/dgyqsp/bj5_balegyr_janssen_r5_guide/" target="_blank" rel="noopener noreferrer">Reddit post here</a></p>
        </div>
        <div>
            <p>All formulas using on the site by <strong>Scollis</strong> and <strong>Foxlery_Shippo</strong></p>
            <p><a href="https://www.reddit.com/r/summonerswar/comments/iea31t/bjr5_dmg_and_ehp_calculator_now_with_artifacts/" target="_blank" rel="noopener noreferrer">Original Reddit post here</a></p>
        </div>
        <div>
            <p>Additional resources and information about how to build a BJ5 team can be found on</p>
            <ul>
                <li>
                    <a href="https://cdn.discordapp.com/attachments/644903276399034388/689166277717262368/Short_BJR5_Guide.jpg" target="_blank" rel="noopener noreferrer">Short Guide</a>
                </li>
                <li>
                    <a href="https://cdn.discordapp.com/attachments/644903276399034388/688564586118643723/BJR5_Guide.jpg" target="_blank" rel="noopener noreferrer">Detailed Guide</a>
                </li>
            </ul>
        </div>

    </section>
}

export default Credits